<!--
/*******************************************************************************
*@ 컴포넌트명   : Table.vue
*@ 컴포넌트설명 : table 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div class="cont-tit">
      <h6>{{title || $t(titleI18n)}}</h6>
    </div>
    <dl :class="['dlist', `dlist-item--${cssType}`]">
      <slot name="content" />
    </dl>
  </article>
</template>
<script>
import { commonProps } from "@/mixins/basicComponent";
export default {
  mixins: [commonProps],
};
</script>